import type { CustomersFiltersType } from '@components/customers/grid/CustomersFilter'

import { makeFilter, makeSearchFilter } from '@@partner:helpers/crud/filters'
import { BusinessProfilesFiltersType } from '@components/businessProfiles/grid/BusinessProfilesFilter'
import { CommonStatusUILabel } from '@@partner:types:app'
import { formatBusinessProfileStatus } from './formatters/businessProfile'
import { BUSINESS_PROFILE } from '@hive/status'

interface BusinessProfileStatusUISettings extends CommonStatusUILabel {
  value: string
}

export const prepareBusinessProfilesFilter = (filters: BusinessProfilesFiltersType) => {
  const statusFilter = makeFilter('status', 'contains', filters.status)
  const searchXidFilter = makeSearchFilter(
    'xid',
    'starts_with',
    filters.xid
  )
  const searchNameFilter = makeSearchFilter(
    'name',
    'starts_with',
    filters.name
  )
  const searchTinFilter = makeSearchFilter(
    'tin',
    'starts_with',
    filters.tin
  )

  return {
    and: [
      statusFilter,
      searchXidFilter,
      searchNameFilter,
      searchTinFilter,
    ]
  }
}

export function getSearchableBusinessProfilesStatus (): BusinessProfileStatusUISettings[] {
  const SEARCHABLE_CUSTOMER_STATUS = [
    BUSINESS_PROFILE.ACTIVE,
    BUSINESS_PROFILE.BLOCKED_INVISIBLE,
    BUSINESS_PROFILE.BLOCKED,
    BUSINESS_PROFILE.PENDING
  ]

  return SEARCHABLE_CUSTOMER_STATUS.map((statusCode) => {
    const statusConfig = formatBusinessProfileStatus(statusCode)

    return {
      value: statusCode,
      label: statusConfig.label,
      color: statusConfig.color
    }
  })
}